import { keys } from 'lodash';
import { FiltersConfig } from 'components/FilterUtils';

export interface Groups {
  [key: string]: string;
}

export const getGroups = (groups: Groups, config: FiltersConfig) =>
  keys(groups).map((currentGroup) => config.filter(({ group }) => group === currentGroup));
